export default __webpack_public_path__ + "static/eth-global-tapei-52fe02156872377a1cf7839df238eb7d.png";